



































import {
  defineComponent,
  computed,
  ref,
  onMounted,
  useRoute
} from '@nuxtjs/composition-api';
import {useGtm, useNews} from '~/composables';
import { toString } from "lodash-es";
import utils from '~/helpers/utils';
import {
  SfList,
  SfHeading,
  SfLoader,
  SfPagination,
} from '@storefront-ui/vue';
export default defineComponent({
  name: 'ComparePage',
  components: {
    SfHeading,
    SfList,
    SfPagination,
    SfLoader,
  },
  setup() {
    const {
      getProductNewsList
    } = useNews();      
    const loading = ref(true);
    const newsList = ref([]);
    const currentPage = ref(1);
    const totalPage = ref(1);
    const pageSize = ref(15);
    const totalCount = ref(1);
    const route = useRoute();
    const { formatDate } = utils();
    currentPage.value = Number(route.value.query?.page) ? Number(route.value.query?.page) : 1;
    const getNews = async () => {
      const data = await getProductNewsList({
        pageSize: pageSize.value,
        pageId: 1,
        dir: "DESC"
      });
      totalCount.value = data['getProductNews']?.total_count;
      totalPage.value = data['getProductNews']?.total_pages;
      loading.value = false;
      return data['getProductNews']?.data;
    };
    const screenWidth = ref(0);
   
    const resizeScreen = () => {
      screenWidth.value = document.body.clientWidth;
    };
    onMounted( async () => {
      screenWidth.value = document.body.clientWidth;
      newsList.value =  await getNews();
      window.addEventListener('resize', resizeScreen);
    });
    return {
      newsList,
      currentPage,
      totalCount,
      totalPage,
      loading,
      formatDate,
      screenWidth
    };
  },
});
